import { ReactComponent as InterviewIcon } from "../assets/images/icons/InterviewIcon.svg";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ContentPasteGoOutlinedIcon from "@mui/icons-material/ContentPasteGoOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import TerminalIcon from "@mui/icons-material/Terminal";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import TodayIcon from "@mui/icons-material/Today";
import CelebrationIcon from "@mui/icons-material/Celebration";
import HttpsIcon from "@mui/icons-material/Https";
// icons
const icons = {
  AssignmentOutlinedIcon,
  WorkOutlineOutlinedIcon,
  SchoolOutlinedIcon,
  AccountBalanceOutlinedIcon,
  HomeOutlinedIcon,
  PersonOutlinedIcon,
  ContentPasteGoOutlinedIcon,
  DashboardOutlinedIcon,
  PeopleOutlineIcon,
  FactCheckOutlinedIcon,
  EventAvailableIcon,
  TerminalIcon,
  TodayIcon,
  CelebrationIcon,
  ViewKanbanOutlinedIcon,
  interviewIcon: <InterviewIcon />,
  HttpsIcon,
};
// ==============================|| MENU ITEMS - COMPANY PAGE ||============================== //
const employeeType = {
  id: "employee",
  type: "only_employee_view",
  children: [
    {
      id: "project-employee",
      title: "My Projects ",
      type: "item",
      url: "/projects",
      icon: icons.FactCheckOutlinedIcon,
    },
    {
      id: "pms",
      title: "PMS ",
      type: "item",
      icon: icons.ViewKanbanOutlinedIcon,
    },
    {
      id: "attendance",
      title: "Attendance",
      type: "item",
      url: "/attendance",
      icon: icons.EventAvailableIcon,
    },
    // {
    //   id: "leave",
    //   title: "Leave",
    //   type: "item",
    //   url: "/leave",
    //   icon: icons.ContentPasteGoOutlinedIcon,
    // },
    // {
    //   id: "holidays",
    //   title: "Holidays",
    //   url: "/holidays",
    //   icon: icons.EventAvailableIcon,
    // },
    {
      id: "interview",
      title: "Interviews",
      type: "item",
      url: "/interview",
      icon: icons.interviewIcon,
    },
    {
      id: "credential",
      title: "Credentials",
      type: "item",
      url: "/credential",
      icon: icons.HttpsIcon,
    },
    {
      id: "personal-details",
      title: "Personal",
      type: "item",
      url: "/personal-details",
      icon: icons.PersonOutlinedIcon,
      children: [
        // {
        //     id: 'project-employee',
        //     title: 'My Projects ',
        //     type: 'item',
        //     url: '/projects',
        //     icon: icons.FactCheckOutlinedIcon,
        // },
        {
          id: "document",
          title: "Documents",
          type: "item",
          url: "/document",
          icon: icons.AssignmentOutlinedIcon,
        },
        {
          id: "work",
          title: "Previous Experience",
          type: "item",
          url: "/work",
          icon: icons.WorkOutlineOutlinedIcon,
        },
        {
          id: "education",
          title: "Education",
          type: "item",
          url: "/education",
          icon: icons.SchoolOutlinedIcon,
        },
        {
          id: "bank-details",
          title: "Bank Details",
          type: "item",
          url: "/bank-details",
          icon: icons.AccountBalanceOutlinedIcon,
        },
        // {
        //   id: 'leave',
        //   title: 'Leave',
        //   type: 'item',
        //   url: '/leave',
        //   icon: icons.ContentPasteGoOutlinedIcon,

        // },
        {
          id: "holidays",
          title: "Holidays",
          url: "/holidays",
          icon: icons.TodayIcon,
        },
        {
          id: "address",
          title: "Address",
          type: "item",
          url: "/address",
          icon: icons.HomeOutlinedIcon,
        },
        {
          id: "nominee",
          title: "Nominee",
          type: "item",
          url: "/nominee",
          icon: icons.PeopleOutlineIcon,
        },
        {
          id: "technologies",
          title: "Technologies",
          type: "item",
          url: "/technologies",
          icon: icons.TerminalIcon,
        },
      ],
    },
    // {
    //   id: "credential",
    //   title: "Credential",
    //   type: "item",
    //   url: "/credential",
    //   icon: icons.EventAvailableIcon,
    // },
  ],
};

export default employeeType;
